const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// HexaDent brand heading color — applied to large storefront headings only.
(() => {
  const style = document.createElement('style');
  style.id = 'hexadent-global-heading-color';
  style.textContent = `
    #MainContent h1,
    #MainContent h2,
    #MainContent h3,
    #MainContent .h0,
    #MainContent .h1,
    #MainContent .h2,
    #MainContent .hxl,
    #MainContent .hxxl,
    #MainContent .title,
    #MainContent .banner__heading,
    #MainContent .rich-text__heading,
    #MainContent .image-with-text__heading {
      color: #173f2c !important;
    }
  `;
  document.head.appendChild(style);
})();
